import type {ReactElement} from 'react';
import React from 'react';
import type {MediaControlsItemProps} from '@Components/contextual-menu/components/media-controls-item';
import {Option} from '@Components/contextual-menu/components/option';
import {MediaControls} from '@Components/contextual-menu/components/media-controls';

interface ContextualMenuMediaControlOptionsProps {
  id: string;
  className?: string;
  items: Array<MediaControlsItemProps>;

  onClick?(id: string): void;
}

export function ContextualMenuMediaControlOptions({className = '', ...props}: ContextualMenuMediaControlOptionsProps): ReactElement | null {
  return (
    <Option
      key={props.id}
      showControlInCenter
      optionControl={
        <MediaControls
          className={className}
          items={props.items}
          onClick={(id): void => {
            if (props.onClick) {
              props.onClick(id);
            }
          }}
        />
      }
    />
  );
}
